import React, { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
export default function NotFound() {
  const location = useLocation();
  useEffect(() => {
    console.error('404 Error: User attempted to access non-existent route:', location.pathname);
  }, [location.pathname]);
  return <div className="min-h-screen flex items-center justify-center bg-[#f5f5f5]" data-id="element-208">
      <div className="text-center" data-id="element-209">
        <h1 className="text-4xl font-bold mb-4 text-black" data-id="element-210">404</h1>
        <p className="text-xl text-gray-600 mb-6" data-id="element-211">Oops! Page not found</p>
        <Link to="/" className="text-blue-600 hover:text-blue-800 underline font-medium" data-id="element-212">
          Return to Home
        </Link>
      </div>
    </div>;
}